import { createSlice } from "@reduxjs/toolkit";
var initialState = { open: false };
export var MenuSlice = createSlice({ name: "menuOpen", initialState: initialState, reducers: { setOpenMenu: function setOpenMenu(state, action) { state.open = action.payload; } } });
var setOpenMenu = MenuSlice.actions.setOpenMenu;
export { setOpenMenu };
export default MenuSlice.reducer;
